exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.img-thumbnail[data-v-682dda27] {\n  height: 70px;\n}\n", ""]);

// exports
